import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, CardActions, CardContent, Tooltip } from '@mui/material';
export function ConfirmationDialogue(props) {
    const { message, onConfirm, onCancel } = props;
    return (_jsxs(_Fragment, { children: [_jsx(CardContent, { children: message }), _jsx(CardActions, { children: _jsxs(Box, { sx: {
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }, children: [_jsx(Tooltip, { title: "Confirm", children: _jsx(Button, { color: "primary", onClick: onConfirm, children: "Confirm" }) }), _jsx(Tooltip, { title: "Cancel", children: _jsx(Button, { color: "secondary", onClick: onCancel, children: "Cancel" }) })] }) })] }));
}
//# sourceMappingURL=ConfirmationDialogue.js.map